import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";
import * as moment from "moment";
import { SupportService } from "../services/support-service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-plan-subscription",
  templateUrl: "./plan-subscription.component.html",
  styleUrls: ["./plan-subscription.component.scss"],
})
export class PlanSubscriptionComponent implements OnInit {
  planList: any = "";
  isDisabled = false;
  duration;
  isLoad = false;
  testCountryCode = "";
  profilenotfill = false;
  selectedPlanId: string = null;
  subscribing = false;
  primaryCard: any = null;

  constructor(
    private router: Router,
    private supportService: SupportService,
    private appservice: AppService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getPlanList();
    this.viewTestCenter();
    this.loadCard();
  }

  loadCard() {
    this.appservice
      .getcardList(localStorage.getItem("testCenterId").toString())
      .subscribe((res: any) => {
        if (res && res.entity && res.entity.length) {
          this.primaryCard =
            res.entity.find((c) => c.primaryCard) || res.entity[0];
        }
      });
  }

  selectPlan(planId: string) {
    if (this.isDisabled || this.profilenotfill) {
      return;
    }
    this.selectedPlanId = planId;
  }

  onAccept() {
    if (!this.selectedPlanId) {
      return;
    }
    const needsCard = this.selectedPlanId !== "plan-free-trial";
    const hasCard =
      this.primaryCard &&
      this.primaryCard.stripeCustomerId &&
      this.primaryCard.stripePaymentMethodId;
    if (needsCard && !hasCard) {
      this.gotoCard();
      return;
    }

    this.subscribing = true;
    const fromDate = new Date();
    const toDate = new Date();
    toDate.setMonth(toDate.getMonth() + 1);
    const params = {
      testCenterId: localStorage.getItem("testCenterId"),
      subscriptionId: this.selectedPlanId,
      status: "subscription",
      fromDate,
      fromDateStr: moment(fromDate).format("YYYY-MM-DD"),
      toDate,
      toDateStr: moment(toDate).format("YYYY-MM-DD"),
      validDays: 30,
      stripeCustomerId: hasCard ? this.primaryCard.stripeCustomerId : null,
      stripePaymentMethodId: hasCard
        ? this.primaryCard.stripePaymentMethodId
        : null,
    };
    this.appservice.addPlanList(params).subscribe(
      (res: any) => {
        this.subscribing = false;
        if (res && res.status && res.status.status === 200) {
          this.toastr.success("Subscribed successfully");
          this.selectedPlanId = null;
          this.getPlanList();
        } else {
          this.toastr.error("Unable to subscribe. Please try again.");
        }
      },
      () => {
        this.subscribing = false;
        this.toastr.error("Unable to subscribe. Please try again.");
      }
    );
  }

  getPlanList() {
    this.appservice
      .getPlanList(localStorage.getItem("testCenterId").toString())
      .subscribe((plan) => {
        if (plan["status"]["status"] === 200) {
          this.isLoad = true;
          this.planList = plan["entity"];
          if (this.planList) {
            this.isDisabled = !!this.planList.hold_active;
            const comingdate = new Date(this.planList.expiredDateStr);
            comingdate.setHours(0);
            comingdate.setMinutes(0);
            const currentdate = new Date();
            currentdate.setHours(0);
            currentdate.setMinutes(0);
            this.duration =
              Math.round(
                (comingdate.getTime() - currentdate.getTime()) /
                  (1000 * 3600 * 24)
              );
          }
        } else if (plan["status"]["status"] === 204) {
          this.isLoad = true;
        }
      });
  }

  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (
            res["entity"] &&
            res["entity"]["address"] &&
            res["entity"]["address"]["country"]
          ) {
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            this.profilenotfill = false;
          } else {
            this.testCountryCode = localStorage.getItem(
              "currentlocationcountry"
            )
              ? localStorage.getItem("currentlocationcountry") === "101"
                ? "IN"
                : "US"
              : "";
            this.profilenotfill = true;
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  gotoCard() {
    this.supportService.isAccept = true;
    localStorage.setItem("pendingCreditCardOnboarding", "true");
    this.router.navigate([
      `/${localStorage.getItem("testCode").toString()}/credit-card`,
    ]);
  }
}
